import {useEffect, useState} from "react";
import {Client} from "../api/api";
import {useClients} from "./useClients";


export function useClientById(id?: number) {
  const [client, setClient] = useState<Client>(),
    {loadClientById} = useClients()

  useEffect(() => {
    if (id) {
      loadClientById(id).then(setClient)
    }
  }, [id, loadClientById])

  return {client}
}
